/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './../routes/__root'
import { Route as VersionsImport } from './../routes/versions'
import { Route as UtmMakerImport } from './../routes/utm-maker'
import { Route as FlagsImport } from './../routes/flags'
import { Route as WebpageImport } from './../routes/_webpage'
import { Route as AppImport } from './../routes/_app'
import { Route as WebpageIndexImport } from './../routes/_webpage/index'
import { Route as WebpageTermsOfUseImport } from './../routes/_webpage/terms-of-use'
import { Route as WebpagePrivacyPolicyImport } from './../routes/_webpage/privacy-policy'
import { Route as WebpageDisclosureImport } from './../routes/_webpage/disclosure'
import { Route as AppSignupImport } from './../routes/_app/signup'
import { Route as AppResetImport } from './../routes/_app/reset'
import { Route as AppPortfolioImport } from './../routes/_app/portfolio'
import { Route as AppLogoutImport } from './../routes/_app/logout'
import { Route as AppConfirmImport } from './../routes/_app/confirm'
import { Route as AppChecksImport } from './../routes/_app/checks'
import { Route as AppAddressesImport } from './../routes/_app/addresses'
import { Route as AppAccountImport } from './../routes/_app/account'
import { Route as AppTradeIndexImport } from './../routes/_app/trade.index'
import { Route as AppResearchIndexImport } from './../routes/_app/research.index'
import { Route as AppLoginIndexImport } from './../routes/_app/login.index'
import { Route as AppInvestmentsIndexImport } from './../routes/_app/investments.index'
import { Route as AppLoginCodeImport } from './../routes/_app/login.$code'
import { Route as AppVaultSymbolIndexImport } from './../routes/_app/vault.$symbol.index'
import { Route as AppInvestmentsSymbolIndexImport } from './../routes/_app/investments.$symbol.index'
import { Route as AppTradeFundsymbolLimitorderImport } from './../routes/_app/trade.$fund_symbol.limit_order'
import { Route as AppInvestmentsSymbolDocsOfferingImport } from './../routes/_app/investments.$symbol.docs.offering'
import { Route as AppInvestmentsSymbolDocsFundOverviewImport } from './../routes/_app/investments.$symbol.docs.fund-overview'
import { Route as AppInvestmentsSymbolDocsDisclosuresImport } from './../routes/_app/investments.$symbol.docs.disclosures'
import { Route as AppResearchSymbolCompanyCmsnameIndexImport } from './../routes/_app/research.$symbol.company.$cms_name.index'
import { Route as AppResearchSymbolCompanyCmsnameSectionImport } from './../routes/_app/research.$symbol.company.$cms_name.$section'

// Create/Update Routes

const VersionsRoute = VersionsImport.update({
  id: '/versions',
  path: '/versions',
  getParentRoute: () => rootRoute,
} as any)

const UtmMakerRoute = UtmMakerImport.update({
  id: '/utm-maker',
  path: '/utm-maker',
  getParentRoute: () => rootRoute,
} as any)

const FlagsRoute = FlagsImport.update({
  id: '/flags',
  path: '/flags',
  getParentRoute: () => rootRoute,
} as any)

const WebpageRoute = WebpageImport.update({
  id: '/_webpage',
  getParentRoute: () => rootRoute,
} as any)

const AppRoute = AppImport.update({
  id: '/_app',
  getParentRoute: () => rootRoute,
} as any)

const WebpageIndexRoute = WebpageIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WebpageRoute,
} as any)

const WebpageTermsOfUseRoute = WebpageTermsOfUseImport.update({
  id: '/terms-of-use',
  path: '/terms-of-use',
  getParentRoute: () => WebpageRoute,
} as any)

const WebpagePrivacyPolicyRoute = WebpagePrivacyPolicyImport.update({
  id: '/privacy-policy',
  path: '/privacy-policy',
  getParentRoute: () => WebpageRoute,
} as any)

const WebpageDisclosureRoute = WebpageDisclosureImport.update({
  id: '/disclosure',
  path: '/disclosure',
  getParentRoute: () => WebpageRoute,
} as any)

const AppSignupRoute = AppSignupImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => AppRoute,
} as any)

const AppResetRoute = AppResetImport.update({
  id: '/reset',
  path: '/reset',
  getParentRoute: () => AppRoute,
} as any)

const AppPortfolioRoute = AppPortfolioImport.update({
  id: '/portfolio',
  path: '/portfolio',
  getParentRoute: () => AppRoute,
} as any)

const AppLogoutRoute = AppLogoutImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => AppRoute,
} as any)

const AppConfirmRoute = AppConfirmImport.update({
  id: '/confirm',
  path: '/confirm',
  getParentRoute: () => AppRoute,
} as any)

const AppChecksRoute = AppChecksImport.update({
  id: '/checks',
  path: '/checks',
  getParentRoute: () => AppRoute,
} as any)

const AppAddressesRoute = AppAddressesImport.update({
  id: '/addresses',
  path: '/addresses',
  getParentRoute: () => AppRoute,
} as any)

const AppAccountRoute = AppAccountImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AppRoute,
} as any)

const AppTradeIndexRoute = AppTradeIndexImport.update({
  id: '/trade/',
  path: '/trade/',
  getParentRoute: () => AppRoute,
} as any)

const AppResearchIndexRoute = AppResearchIndexImport.update({
  id: '/research/',
  path: '/research/',
  getParentRoute: () => AppRoute,
} as any)

const AppLoginIndexRoute = AppLoginIndexImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => AppRoute,
} as any)

const AppInvestmentsIndexRoute = AppInvestmentsIndexImport.update({
  id: '/investments/',
  path: '/investments/',
  getParentRoute: () => AppRoute,
} as any)

const AppLoginCodeRoute = AppLoginCodeImport.update({
  id: '/login/$code',
  path: '/login/$code',
  getParentRoute: () => AppRoute,
} as any)

const AppVaultSymbolIndexRoute = AppVaultSymbolIndexImport.update({
  id: '/vault/$symbol/',
  path: '/vault/$symbol/',
  getParentRoute: () => AppRoute,
} as any)

const AppInvestmentsSymbolIndexRoute = AppInvestmentsSymbolIndexImport.update({
  id: '/investments/$symbol/',
  path: '/investments/$symbol/',
  getParentRoute: () => AppRoute,
} as any)

const AppTradeFundsymbolLimitorderRoute =
  AppTradeFundsymbolLimitorderImport.update({
    id: '/trade/$fund_symbol/limit_order',
    path: '/trade/$fund_symbol/limit_order',
    getParentRoute: () => AppRoute,
  } as any)

const AppInvestmentsSymbolDocsOfferingRoute =
  AppInvestmentsSymbolDocsOfferingImport.update({
    id: '/investments/$symbol/docs/offering',
    path: '/investments/$symbol/docs/offering',
    getParentRoute: () => AppRoute,
  } as any)

const AppInvestmentsSymbolDocsFundOverviewRoute =
  AppInvestmentsSymbolDocsFundOverviewImport.update({
    id: '/investments/$symbol/docs/fund-overview',
    path: '/investments/$symbol/docs/fund-overview',
    getParentRoute: () => AppRoute,
  } as any)

const AppInvestmentsSymbolDocsDisclosuresRoute =
  AppInvestmentsSymbolDocsDisclosuresImport.update({
    id: '/investments/$symbol/docs/disclosures',
    path: '/investments/$symbol/docs/disclosures',
    getParentRoute: () => AppRoute,
  } as any)

const AppResearchSymbolCompanyCmsnameIndexRoute =
  AppResearchSymbolCompanyCmsnameIndexImport.update({
    id: '/research/$symbol/company/$cms_name/',
    path: '/research/$symbol/company/$cms_name/',
    getParentRoute: () => AppRoute,
  } as any)

const AppResearchSymbolCompanyCmsnameSectionRoute =
  AppResearchSymbolCompanyCmsnameSectionImport.update({
    id: '/research/$symbol/company/$cms_name/$section',
    path: '/research/$symbol/company/$cms_name/$section',
    getParentRoute: () => AppRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppImport
      parentRoute: typeof rootRoute
    }
    '/_webpage': {
      id: '/_webpage'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof WebpageImport
      parentRoute: typeof rootRoute
    }
    '/flags': {
      id: '/flags'
      path: '/flags'
      fullPath: '/flags'
      preLoaderRoute: typeof FlagsImport
      parentRoute: typeof rootRoute
    }
    '/utm-maker': {
      id: '/utm-maker'
      path: '/utm-maker'
      fullPath: '/utm-maker'
      preLoaderRoute: typeof UtmMakerImport
      parentRoute: typeof rootRoute
    }
    '/versions': {
      id: '/versions'
      path: '/versions'
      fullPath: '/versions'
      preLoaderRoute: typeof VersionsImport
      parentRoute: typeof rootRoute
    }
    '/_app/account': {
      id: '/_app/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AppAccountImport
      parentRoute: typeof AppImport
    }
    '/_app/addresses': {
      id: '/_app/addresses'
      path: '/addresses'
      fullPath: '/addresses'
      preLoaderRoute: typeof AppAddressesImport
      parentRoute: typeof AppImport
    }
    '/_app/checks': {
      id: '/_app/checks'
      path: '/checks'
      fullPath: '/checks'
      preLoaderRoute: typeof AppChecksImport
      parentRoute: typeof AppImport
    }
    '/_app/confirm': {
      id: '/_app/confirm'
      path: '/confirm'
      fullPath: '/confirm'
      preLoaderRoute: typeof AppConfirmImport
      parentRoute: typeof AppImport
    }
    '/_app/logout': {
      id: '/_app/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof AppLogoutImport
      parentRoute: typeof AppImport
    }
    '/_app/portfolio': {
      id: '/_app/portfolio'
      path: '/portfolio'
      fullPath: '/portfolio'
      preLoaderRoute: typeof AppPortfolioImport
      parentRoute: typeof AppImport
    }
    '/_app/reset': {
      id: '/_app/reset'
      path: '/reset'
      fullPath: '/reset'
      preLoaderRoute: typeof AppResetImport
      parentRoute: typeof AppImport
    }
    '/_app/signup': {
      id: '/_app/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof AppSignupImport
      parentRoute: typeof AppImport
    }
    '/_webpage/disclosure': {
      id: '/_webpage/disclosure'
      path: '/disclosure'
      fullPath: '/disclosure'
      preLoaderRoute: typeof WebpageDisclosureImport
      parentRoute: typeof WebpageImport
    }
    '/_webpage/privacy-policy': {
      id: '/_webpage/privacy-policy'
      path: '/privacy-policy'
      fullPath: '/privacy-policy'
      preLoaderRoute: typeof WebpagePrivacyPolicyImport
      parentRoute: typeof WebpageImport
    }
    '/_webpage/terms-of-use': {
      id: '/_webpage/terms-of-use'
      path: '/terms-of-use'
      fullPath: '/terms-of-use'
      preLoaderRoute: typeof WebpageTermsOfUseImport
      parentRoute: typeof WebpageImport
    }
    '/_webpage/': {
      id: '/_webpage/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof WebpageIndexImport
      parentRoute: typeof WebpageImport
    }
    '/_app/login/$code': {
      id: '/_app/login/$code'
      path: '/login/$code'
      fullPath: '/login/$code'
      preLoaderRoute: typeof AppLoginCodeImport
      parentRoute: typeof AppImport
    }
    '/_app/investments/': {
      id: '/_app/investments/'
      path: '/investments'
      fullPath: '/investments'
      preLoaderRoute: typeof AppInvestmentsIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/login/': {
      id: '/_app/login/'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AppLoginIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/research/': {
      id: '/_app/research/'
      path: '/research'
      fullPath: '/research'
      preLoaderRoute: typeof AppResearchIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/trade/': {
      id: '/_app/trade/'
      path: '/trade'
      fullPath: '/trade'
      preLoaderRoute: typeof AppTradeIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/trade/$fund_symbol/limit_order': {
      id: '/_app/trade/$fund_symbol/limit_order'
      path: '/trade/$fund_symbol/limit_order'
      fullPath: '/trade/$fund_symbol/limit_order'
      preLoaderRoute: typeof AppTradeFundsymbolLimitorderImport
      parentRoute: typeof AppImport
    }
    '/_app/investments/$symbol/': {
      id: '/_app/investments/$symbol/'
      path: '/investments/$symbol'
      fullPath: '/investments/$symbol'
      preLoaderRoute: typeof AppInvestmentsSymbolIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/vault/$symbol/': {
      id: '/_app/vault/$symbol/'
      path: '/vault/$symbol'
      fullPath: '/vault/$symbol'
      preLoaderRoute: typeof AppVaultSymbolIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/investments/$symbol/docs/disclosures': {
      id: '/_app/investments/$symbol/docs/disclosures'
      path: '/investments/$symbol/docs/disclosures'
      fullPath: '/investments/$symbol/docs/disclosures'
      preLoaderRoute: typeof AppInvestmentsSymbolDocsDisclosuresImport
      parentRoute: typeof AppImport
    }
    '/_app/investments/$symbol/docs/fund-overview': {
      id: '/_app/investments/$symbol/docs/fund-overview'
      path: '/investments/$symbol/docs/fund-overview'
      fullPath: '/investments/$symbol/docs/fund-overview'
      preLoaderRoute: typeof AppInvestmentsSymbolDocsFundOverviewImport
      parentRoute: typeof AppImport
    }
    '/_app/investments/$symbol/docs/offering': {
      id: '/_app/investments/$symbol/docs/offering'
      path: '/investments/$symbol/docs/offering'
      fullPath: '/investments/$symbol/docs/offering'
      preLoaderRoute: typeof AppInvestmentsSymbolDocsOfferingImport
      parentRoute: typeof AppImport
    }
    '/_app/research/$symbol/company/$cms_name/$section': {
      id: '/_app/research/$symbol/company/$cms_name/$section'
      path: '/research/$symbol/company/$cms_name/$section'
      fullPath: '/research/$symbol/company/$cms_name/$section'
      preLoaderRoute: typeof AppResearchSymbolCompanyCmsnameSectionImport
      parentRoute: typeof AppImport
    }
    '/_app/research/$symbol/company/$cms_name/': {
      id: '/_app/research/$symbol/company/$cms_name/'
      path: '/research/$symbol/company/$cms_name'
      fullPath: '/research/$symbol/company/$cms_name'
      preLoaderRoute: typeof AppResearchSymbolCompanyCmsnameIndexImport
      parentRoute: typeof AppImport
    }
  }
}

// Create and export the route tree

interface AppRouteChildren {
  AppAccountRoute: typeof AppAccountRoute
  AppAddressesRoute: typeof AppAddressesRoute
  AppChecksRoute: typeof AppChecksRoute
  AppConfirmRoute: typeof AppConfirmRoute
  AppLogoutRoute: typeof AppLogoutRoute
  AppPortfolioRoute: typeof AppPortfolioRoute
  AppResetRoute: typeof AppResetRoute
  AppSignupRoute: typeof AppSignupRoute
  AppLoginCodeRoute: typeof AppLoginCodeRoute
  AppInvestmentsIndexRoute: typeof AppInvestmentsIndexRoute
  AppLoginIndexRoute: typeof AppLoginIndexRoute
  AppResearchIndexRoute: typeof AppResearchIndexRoute
  AppTradeIndexRoute: typeof AppTradeIndexRoute
  AppTradeFundsymbolLimitorderRoute: typeof AppTradeFundsymbolLimitorderRoute
  AppInvestmentsSymbolIndexRoute: typeof AppInvestmentsSymbolIndexRoute
  AppVaultSymbolIndexRoute: typeof AppVaultSymbolIndexRoute
  AppInvestmentsSymbolDocsDisclosuresRoute: typeof AppInvestmentsSymbolDocsDisclosuresRoute
  AppInvestmentsSymbolDocsFundOverviewRoute: typeof AppInvestmentsSymbolDocsFundOverviewRoute
  AppInvestmentsSymbolDocsOfferingRoute: typeof AppInvestmentsSymbolDocsOfferingRoute
  AppResearchSymbolCompanyCmsnameSectionRoute: typeof AppResearchSymbolCompanyCmsnameSectionRoute
  AppResearchSymbolCompanyCmsnameIndexRoute: typeof AppResearchSymbolCompanyCmsnameIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAccountRoute: AppAccountRoute,
  AppAddressesRoute: AppAddressesRoute,
  AppChecksRoute: AppChecksRoute,
  AppConfirmRoute: AppConfirmRoute,
  AppLogoutRoute: AppLogoutRoute,
  AppPortfolioRoute: AppPortfolioRoute,
  AppResetRoute: AppResetRoute,
  AppSignupRoute: AppSignupRoute,
  AppLoginCodeRoute: AppLoginCodeRoute,
  AppInvestmentsIndexRoute: AppInvestmentsIndexRoute,
  AppLoginIndexRoute: AppLoginIndexRoute,
  AppResearchIndexRoute: AppResearchIndexRoute,
  AppTradeIndexRoute: AppTradeIndexRoute,
  AppTradeFundsymbolLimitorderRoute: AppTradeFundsymbolLimitorderRoute,
  AppInvestmentsSymbolIndexRoute: AppInvestmentsSymbolIndexRoute,
  AppVaultSymbolIndexRoute: AppVaultSymbolIndexRoute,
  AppInvestmentsSymbolDocsDisclosuresRoute:
    AppInvestmentsSymbolDocsDisclosuresRoute,
  AppInvestmentsSymbolDocsFundOverviewRoute:
    AppInvestmentsSymbolDocsFundOverviewRoute,
  AppInvestmentsSymbolDocsOfferingRoute: AppInvestmentsSymbolDocsOfferingRoute,
  AppResearchSymbolCompanyCmsnameSectionRoute:
    AppResearchSymbolCompanyCmsnameSectionRoute,
  AppResearchSymbolCompanyCmsnameIndexRoute:
    AppResearchSymbolCompanyCmsnameIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface WebpageRouteChildren {
  WebpageDisclosureRoute: typeof WebpageDisclosureRoute
  WebpagePrivacyPolicyRoute: typeof WebpagePrivacyPolicyRoute
  WebpageTermsOfUseRoute: typeof WebpageTermsOfUseRoute
  WebpageIndexRoute: typeof WebpageIndexRoute
}

const WebpageRouteChildren: WebpageRouteChildren = {
  WebpageDisclosureRoute: WebpageDisclosureRoute,
  WebpagePrivacyPolicyRoute: WebpagePrivacyPolicyRoute,
  WebpageTermsOfUseRoute: WebpageTermsOfUseRoute,
  WebpageIndexRoute: WebpageIndexRoute,
}

const WebpageRouteWithChildren =
  WebpageRoute._addFileChildren(WebpageRouteChildren)

export interface FileRoutesByFullPath {
  '': typeof WebpageRouteWithChildren
  '/flags': typeof FlagsRoute
  '/utm-maker': typeof UtmMakerRoute
  '/versions': typeof VersionsRoute
  '/account': typeof AppAccountRoute
  '/addresses': typeof AppAddressesRoute
  '/checks': typeof AppChecksRoute
  '/confirm': typeof AppConfirmRoute
  '/logout': typeof AppLogoutRoute
  '/portfolio': typeof AppPortfolioRoute
  '/reset': typeof AppResetRoute
  '/signup': typeof AppSignupRoute
  '/disclosure': typeof WebpageDisclosureRoute
  '/privacy-policy': typeof WebpagePrivacyPolicyRoute
  '/terms-of-use': typeof WebpageTermsOfUseRoute
  '/': typeof WebpageIndexRoute
  '/login/$code': typeof AppLoginCodeRoute
  '/investments': typeof AppInvestmentsIndexRoute
  '/login': typeof AppLoginIndexRoute
  '/research': typeof AppResearchIndexRoute
  '/trade': typeof AppTradeIndexRoute
  '/trade/$fund_symbol/limit_order': typeof AppTradeFundsymbolLimitorderRoute
  '/investments/$symbol': typeof AppInvestmentsSymbolIndexRoute
  '/vault/$symbol': typeof AppVaultSymbolIndexRoute
  '/investments/$symbol/docs/disclosures': typeof AppInvestmentsSymbolDocsDisclosuresRoute
  '/investments/$symbol/docs/fund-overview': typeof AppInvestmentsSymbolDocsFundOverviewRoute
  '/investments/$symbol/docs/offering': typeof AppInvestmentsSymbolDocsOfferingRoute
  '/research/$symbol/company/$cms_name/$section': typeof AppResearchSymbolCompanyCmsnameSectionRoute
  '/research/$symbol/company/$cms_name': typeof AppResearchSymbolCompanyCmsnameIndexRoute
}

export interface FileRoutesByTo {
  '': typeof AppRouteWithChildren
  '/flags': typeof FlagsRoute
  '/utm-maker': typeof UtmMakerRoute
  '/versions': typeof VersionsRoute
  '/account': typeof AppAccountRoute
  '/addresses': typeof AppAddressesRoute
  '/checks': typeof AppChecksRoute
  '/confirm': typeof AppConfirmRoute
  '/logout': typeof AppLogoutRoute
  '/portfolio': typeof AppPortfolioRoute
  '/reset': typeof AppResetRoute
  '/signup': typeof AppSignupRoute
  '/disclosure': typeof WebpageDisclosureRoute
  '/privacy-policy': typeof WebpagePrivacyPolicyRoute
  '/terms-of-use': typeof WebpageTermsOfUseRoute
  '/': typeof WebpageIndexRoute
  '/login/$code': typeof AppLoginCodeRoute
  '/investments': typeof AppInvestmentsIndexRoute
  '/login': typeof AppLoginIndexRoute
  '/research': typeof AppResearchIndexRoute
  '/trade': typeof AppTradeIndexRoute
  '/trade/$fund_symbol/limit_order': typeof AppTradeFundsymbolLimitorderRoute
  '/investments/$symbol': typeof AppInvestmentsSymbolIndexRoute
  '/vault/$symbol': typeof AppVaultSymbolIndexRoute
  '/investments/$symbol/docs/disclosures': typeof AppInvestmentsSymbolDocsDisclosuresRoute
  '/investments/$symbol/docs/fund-overview': typeof AppInvestmentsSymbolDocsFundOverviewRoute
  '/investments/$symbol/docs/offering': typeof AppInvestmentsSymbolDocsOfferingRoute
  '/research/$symbol/company/$cms_name/$section': typeof AppResearchSymbolCompanyCmsnameSectionRoute
  '/research/$symbol/company/$cms_name': typeof AppResearchSymbolCompanyCmsnameIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/_app': typeof AppRouteWithChildren
  '/_webpage': typeof WebpageRouteWithChildren
  '/flags': typeof FlagsRoute
  '/utm-maker': typeof UtmMakerRoute
  '/versions': typeof VersionsRoute
  '/_app/account': typeof AppAccountRoute
  '/_app/addresses': typeof AppAddressesRoute
  '/_app/checks': typeof AppChecksRoute
  '/_app/confirm': typeof AppConfirmRoute
  '/_app/logout': typeof AppLogoutRoute
  '/_app/portfolio': typeof AppPortfolioRoute
  '/_app/reset': typeof AppResetRoute
  '/_app/signup': typeof AppSignupRoute
  '/_webpage/disclosure': typeof WebpageDisclosureRoute
  '/_webpage/privacy-policy': typeof WebpagePrivacyPolicyRoute
  '/_webpage/terms-of-use': typeof WebpageTermsOfUseRoute
  '/_webpage/': typeof WebpageIndexRoute
  '/_app/login/$code': typeof AppLoginCodeRoute
  '/_app/investments/': typeof AppInvestmentsIndexRoute
  '/_app/login/': typeof AppLoginIndexRoute
  '/_app/research/': typeof AppResearchIndexRoute
  '/_app/trade/': typeof AppTradeIndexRoute
  '/_app/trade/$fund_symbol/limit_order': typeof AppTradeFundsymbolLimitorderRoute
  '/_app/investments/$symbol/': typeof AppInvestmentsSymbolIndexRoute
  '/_app/vault/$symbol/': typeof AppVaultSymbolIndexRoute
  '/_app/investments/$symbol/docs/disclosures': typeof AppInvestmentsSymbolDocsDisclosuresRoute
  '/_app/investments/$symbol/docs/fund-overview': typeof AppInvestmentsSymbolDocsFundOverviewRoute
  '/_app/investments/$symbol/docs/offering': typeof AppInvestmentsSymbolDocsOfferingRoute
  '/_app/research/$symbol/company/$cms_name/$section': typeof AppResearchSymbolCompanyCmsnameSectionRoute
  '/_app/research/$symbol/company/$cms_name/': typeof AppResearchSymbolCompanyCmsnameIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | ''
    | '/flags'
    | '/utm-maker'
    | '/versions'
    | '/account'
    | '/addresses'
    | '/checks'
    | '/confirm'
    | '/logout'
    | '/portfolio'
    | '/reset'
    | '/signup'
    | '/disclosure'
    | '/privacy-policy'
    | '/terms-of-use'
    | '/'
    | '/login/$code'
    | '/investments'
    | '/login'
    | '/research'
    | '/trade'
    | '/trade/$fund_symbol/limit_order'
    | '/investments/$symbol'
    | '/vault/$symbol'
    | '/investments/$symbol/docs/disclosures'
    | '/investments/$symbol/docs/fund-overview'
    | '/investments/$symbol/docs/offering'
    | '/research/$symbol/company/$cms_name/$section'
    | '/research/$symbol/company/$cms_name'
  fileRoutesByTo: FileRoutesByTo
  to:
    | ''
    | '/flags'
    | '/utm-maker'
    | '/versions'
    | '/account'
    | '/addresses'
    | '/checks'
    | '/confirm'
    | '/logout'
    | '/portfolio'
    | '/reset'
    | '/signup'
    | '/disclosure'
    | '/privacy-policy'
    | '/terms-of-use'
    | '/'
    | '/login/$code'
    | '/investments'
    | '/login'
    | '/research'
    | '/trade'
    | '/trade/$fund_symbol/limit_order'
    | '/investments/$symbol'
    | '/vault/$symbol'
    | '/investments/$symbol/docs/disclosures'
    | '/investments/$symbol/docs/fund-overview'
    | '/investments/$symbol/docs/offering'
    | '/research/$symbol/company/$cms_name/$section'
    | '/research/$symbol/company/$cms_name'
  id:
    | '__root__'
    | '/_app'
    | '/_webpage'
    | '/flags'
    | '/utm-maker'
    | '/versions'
    | '/_app/account'
    | '/_app/addresses'
    | '/_app/checks'
    | '/_app/confirm'
    | '/_app/logout'
    | '/_app/portfolio'
    | '/_app/reset'
    | '/_app/signup'
    | '/_webpage/disclosure'
    | '/_webpage/privacy-policy'
    | '/_webpage/terms-of-use'
    | '/_webpage/'
    | '/_app/login/$code'
    | '/_app/investments/'
    | '/_app/login/'
    | '/_app/research/'
    | '/_app/trade/'
    | '/_app/trade/$fund_symbol/limit_order'
    | '/_app/investments/$symbol/'
    | '/_app/vault/$symbol/'
    | '/_app/investments/$symbol/docs/disclosures'
    | '/_app/investments/$symbol/docs/fund-overview'
    | '/_app/investments/$symbol/docs/offering'
    | '/_app/research/$symbol/company/$cms_name/$section'
    | '/_app/research/$symbol/company/$cms_name/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  WebpageRoute: typeof WebpageRouteWithChildren
  FlagsRoute: typeof FlagsRoute
  UtmMakerRoute: typeof UtmMakerRoute
  VersionsRoute: typeof VersionsRoute
}

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  WebpageRoute: WebpageRouteWithChildren,
  FlagsRoute: FlagsRoute,
  UtmMakerRoute: UtmMakerRoute,
  VersionsRoute: VersionsRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_app",
        "/_webpage",
        "/flags",
        "/utm-maker",
        "/versions"
      ]
    },
    "/_app": {
      "filePath": "_app.tsx",
      "children": [
        "/_app/account",
        "/_app/addresses",
        "/_app/checks",
        "/_app/confirm",
        "/_app/logout",
        "/_app/portfolio",
        "/_app/reset",
        "/_app/signup",
        "/_app/login/$code",
        "/_app/investments/",
        "/_app/login/",
        "/_app/research/",
        "/_app/trade/",
        "/_app/trade/$fund_symbol/limit_order",
        "/_app/investments/$symbol/",
        "/_app/vault/$symbol/",
        "/_app/investments/$symbol/docs/disclosures",
        "/_app/investments/$symbol/docs/fund-overview",
        "/_app/investments/$symbol/docs/offering",
        "/_app/research/$symbol/company/$cms_name/$section",
        "/_app/research/$symbol/company/$cms_name/"
      ]
    },
    "/_webpage": {
      "filePath": "_webpage.tsx",
      "children": [
        "/_webpage/disclosure",
        "/_webpage/privacy-policy",
        "/_webpage/terms-of-use",
        "/_webpage/"
      ]
    },
    "/flags": {
      "filePath": "flags.tsx"
    },
    "/utm-maker": {
      "filePath": "utm-maker.tsx"
    },
    "/versions": {
      "filePath": "versions.tsx"
    },
    "/_app/account": {
      "filePath": "_app/account.tsx",
      "parent": "/_app"
    },
    "/_app/addresses": {
      "filePath": "_app/addresses.tsx",
      "parent": "/_app"
    },
    "/_app/checks": {
      "filePath": "_app/checks.tsx",
      "parent": "/_app"
    },
    "/_app/confirm": {
      "filePath": "_app/confirm.tsx",
      "parent": "/_app"
    },
    "/_app/logout": {
      "filePath": "_app/logout.tsx",
      "parent": "/_app"
    },
    "/_app/portfolio": {
      "filePath": "_app/portfolio.tsx",
      "parent": "/_app"
    },
    "/_app/reset": {
      "filePath": "_app/reset.tsx",
      "parent": "/_app"
    },
    "/_app/signup": {
      "filePath": "_app/signup.tsx",
      "parent": "/_app"
    },
    "/_webpage/disclosure": {
      "filePath": "_webpage/disclosure.tsx",
      "parent": "/_webpage"
    },
    "/_webpage/privacy-policy": {
      "filePath": "_webpage/privacy-policy.tsx",
      "parent": "/_webpage"
    },
    "/_webpage/terms-of-use": {
      "filePath": "_webpage/terms-of-use.tsx",
      "parent": "/_webpage"
    },
    "/_webpage/": {
      "filePath": "_webpage/index.tsx",
      "parent": "/_webpage"
    },
    "/_app/login/$code": {
      "filePath": "_app/login.$code.tsx",
      "parent": "/_app"
    },
    "/_app/investments/": {
      "filePath": "_app/investments.index.tsx",
      "parent": "/_app"
    },
    "/_app/login/": {
      "filePath": "_app/login.index.tsx",
      "parent": "/_app"
    },
    "/_app/research/": {
      "filePath": "_app/research.index.tsx",
      "parent": "/_app"
    },
    "/_app/trade/": {
      "filePath": "_app/trade.index.tsx",
      "parent": "/_app"
    },
    "/_app/trade/$fund_symbol/limit_order": {
      "filePath": "_app/trade.$fund_symbol.limit_order.tsx",
      "parent": "/_app"
    },
    "/_app/investments/$symbol/": {
      "filePath": "_app/investments.$symbol.index.tsx",
      "parent": "/_app"
    },
    "/_app/vault/$symbol/": {
      "filePath": "_app/vault.$symbol.index.tsx",
      "parent": "/_app"
    },
    "/_app/investments/$symbol/docs/disclosures": {
      "filePath": "_app/investments.$symbol.docs.disclosures.tsx",
      "parent": "/_app"
    },
    "/_app/investments/$symbol/docs/fund-overview": {
      "filePath": "_app/investments.$symbol.docs.fund-overview.tsx",
      "parent": "/_app"
    },
    "/_app/investments/$symbol/docs/offering": {
      "filePath": "_app/investments.$symbol.docs.offering.tsx",
      "parent": "/_app"
    },
    "/_app/research/$symbol/company/$cms_name/$section": {
      "filePath": "_app/research.$symbol.company.$cms_name.$section.tsx",
      "parent": "/_app"
    },
    "/_app/research/$symbol/company/$cms_name/": {
      "filePath": "_app/research.$symbol.company.$cms_name.index.tsx",
      "parent": "/_app"
    }
  }
}
ROUTE_MANIFEST_END */
